import { PlayerShipClass } from '@entities/PlayerShips';

/**
 * The fixed fleet each level fielded before the persistent roster existed. Saves
 * from that time are given the fleet of their highest unlocked level, and each
 * level's deployment limit matches the size of its old fleet.
 */
export const LEGACY_LEVEL_FLEETS: Record<number, PlayerShipClass[]> = {
  1: ['fighter'],
  2: ['fighter', 'dart'],
  3: ['fighter', 'dart', 'gunship'],
  4: ['fighter', 'dart', 'gunship', 'longbow'],
  5: ['fighter', 'dart', 'gunship', 'longbow', 'warden'],
  6: ['dart', 'dart', 'fighter'],
  7: ['gunship', 'longbow', 'fighter'],
  8: ['longbow', 'longbow', 'fighter', 'gunship'],
  9: ['warden', 'dart', 'fighter', 'gunship'],
  10: ['longbow', 'gunship', 'warden', 'fighter'],
  11: ['dart', 'dart', 'fighter', 'longbow', 'warden'],
  12: ['longbow', 'longbow', 'gunship', 'gunship', 'warden'],
  13: ['gunship', 'warden', 'fighter', 'dart', 'longbow'],
  14: ['gunship', 'gunship', 'longbow', 'warden', 'fighter'],
  15: ['fighter', 'dart', 'gunship', 'longbow', 'warden'],
};
